import { render, staticRenderFns } from "./PriorityDetails.vue?vue&type=template&id=713e4519&scoped=true"
import script from "./PriorityDetails.vue?vue&type=script&lang=js"
export * from "./PriorityDetails.vue?vue&type=script&lang=js"
import style0 from "./PriorityDetails.vue?vue&type=style&index=0&id=713e4519&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713e4519",
  null
  
)

export default component.exports